import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/images/Logo.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  class: "layout-login__logo",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_2 = { class: "layout-login__inner-title-invite" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "layout-login__invite-title" }, "Добро пожаловать,", -1)
const _hoisted_4 = { class: "layout-login__invite-subtitle" }
const _hoisted_5 = { class: "layout-login__wrap-input" }
const _hoisted_6 = { class: "layout-login__input-addons" }
const _hoisted_7 = { class: "layout-login__input-addons" }

import {
  KeyIcon,
  EyeIcon,
  EyeSlashIcon,
} from "tir-style-system/icons/outline";
import { TirPmInput } from "tir-pm-input";

import { computed, onMounted, ref, watch } from "vue";
import { TirPmSpinner } from "tir-pm-spinner";
import ApiService from "@/shared/api";
import { useRoute, useRouter } from "vue-router";
import { CurrentUser, CurrentUserModel, UserRoleEnum } from "tir-pm-user-core";
import TypeRoles from "@/shared/api/Main/dataSource/api/users/implementation/TypeRoles";


export default /*#__PURE__*/_defineComponent({
  __name: 'InviteUserPage',
  setup(__props, { expose: __expose }) {

const router = useRouter();

// Глобальный сервис
const api = new ApiService();

let route = useRoute();

/**
 * Забрать токен с урла
 */
let routeQueryToken = ref(route.params.token);
if (routeQueryToken.value[routeQueryToken.value.length - 1] == "/") {
  routeQueryToken.value = routeQueryToken.value.slice(0, -1);
}

// Переменные для паролей
const firstPassword = ref("");
const secondPassword = ref("");

// Переменные для показа или скрытия паролей
const showFirstPassword = ref(false);
const showSecondPassword = ref(false);

// Переменная чтобы показать компонент ошибки
const showPlateWarning = ref(false);

// Переменная в которую заходит текст ошибки
const errorMessage = ref("");

/**
 * Блок элемента контента
 */
const $currentComponentWrapper = ref(null);

/**
 * Текущая высота элемента контента
 */
const currentHeightComponent = ref(null);

/**
 * Индикатор загрузки юзера
 */
const isLoadingCurrentUser = ref(true);

/**
 * Индикатор загрузки юзера
 */
const isSuccessEqualsPasword = ref(false);

/**
 * Текущий юзер
 **/
const currentUserNameFromToken = ref("");

/**
 * Лоадер для кнопки
 */
const loadingRequest = ref(false);

/**
 * Перерасчет высоты
 */
const loadingRequestComputed = computed(() => {
  return loadingRequest.value;
});

/**
 *  Переключение типов паролей для инпутов, чтобы показать введенное
 */
const typeFirstPassword = computed(() => {
  return showFirstPassword.value ? "text" : "password";
});
const typeSecondPassword = computed(() => {
  return showSecondPassword.value ? "text" : "password";
});

/**
 * Функция валидации
 */
const checkValidate = computed(() => {
  return (
    firstPassword.value.length &&
    secondPassword.value.length &&
    firstPassword.value == secondPassword.value
  );
});

const mapRole = (role: TypeRoles) => {
  return {
    [TypeRoles.Employee]: UserRoleEnum.Employee,
    [TypeRoles.Owner]: UserRoleEnum.Owner,
    [TypeRoles.NamespaceAdmin]: UserRoleEnum.NamespaceAdmin,
    [TypeRoles.ProjectAdmin]: UserRoleEnum.ProjectAdmin,
  }[role];
};

/**
 * Функция для добавления юзера и редиректа при успешном заполнении
 */
const onInviteUser = async () => {
  loadingRequest.value = true;
  if (isSuccessEqualsPasword.value) {
    try {
      await api.Main.UsersService.activateAsync({
        Token: routeQueryToken.value,
        Password: secondPassword.value,
      });
      const userResp = await api.Main.UsersService.getCurrentUserAsync();
      CurrentUser.set(
        new CurrentUserModel({
          Id: userResp.Id,
          Email: userResp.Email,
          FirstName: userResp.FirstName,
          LastName: userResp.LastName,
          MiddleName: userResp.MiddleName,
          AvatarColor: userResp.AvatarColor,
          Foto: userResp.Foto,
          Roles: userResp.Roles.map(mapRole),
        })
      );
      showPlateWarning.value = false;
      router.push("/projects");
    } catch (err: any) {
      console.error(err);
      isSuccessEqualsPasword.value = false;
      showPlateWarning.value = true;
      errorMessage.value = err?.ErrorMessage;
    }
  } else {
    isSuccessEqualsPasword.value = false;
    showPlateWarning.value = true;
    errorMessage.value = "Пароли не совпадают";
  }
  loadingRequest.value = false;
  updateHeight();
};

/**
 * Функция активируемая набором в инпут
 */
const onTypeOfInput = () => {
  showPlateWarning.value = false;
  errorMessage.value = "";
};

/**
 * Функция обновления высоты
 */
const updateHeight = () => {
  setTimeout(() => {
    currentHeightComponent.value = $currentComponentWrapper.value?.offsetHeight;
  });
};

/**
 * Получить имя
 */
onMounted(async () => {
  currentHeightComponent.value = $currentComponentWrapper.value?.offsetHeight;
  try {
    let { FirstName, LastName, MiddleName } =
      await api.Main.UsersService.getUserShortInfoByTokenActivationAsync({
        Token: routeQueryToken.value,
      });

    currentUserNameFromToken.value = `${LastName} ${FirstName} ${MiddleName}`;
    isLoadingCurrentUser.value = false;
  } catch (error) {
    router.push("/login");
  }
});

watch(checkValidate, () => {
  if (checkValidate.value) {
    isSuccessEqualsPasword.value = true;
  } else {
    isSuccessEqualsPasword.value = false;
  }
});

__expose({
  changerMethodFromComponent: onInviteUser,
  currentHeightComponent: currentHeightComponent,
  isLoadingIntoComponent: loadingRequestComputed,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "layout-login__body",
    ref_key: "$currentComponentWrapper",
    ref: $currentComponentWrapper
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (isLoadingCurrentUser.value)
        ? (_openBlock(), _createBlock(_unref(TirPmSpinner), { key: 0 }))
        : _createCommentVNode("", true),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(currentUserNameFromToken.value), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_unref(TirPmInput), {
        isAutocomplete: "",
        label: "Пароль",
        type: typeFirstPassword.value,
        modelValue: firstPassword.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((firstPassword).value = $event)),
        placeholder: "",
        isWithSuccess: isSuccessEqualsPasword.value,
        onInput: onTypeOfInput,
        isWithHint: false
      }, {
        leftInputAddons: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(KeyIcon))
          ])
        ]),
        hintMessage: _withCtx(() => []),
        rightInputAddons: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["layout-login__input-addons layout-login__input-addons--action", {
              'layout-login__input-addons--show': firstPassword.value.length,
            }])
          }, [
            (!showFirstPassword.value)
              ? (_openBlock(), _createBlock(_unref(EyeIcon), {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showFirstPassword.value = !showFirstPassword.value))
                }))
              : _createCommentVNode("", true),
            (showFirstPassword.value)
              ? (_openBlock(), _createBlock(_unref(EyeSlashIcon), {
                  key: 1,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showFirstPassword.value = !showFirstPassword.value))
                }))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _: 1
      }, 8, ["type", "modelValue", "isWithSuccess"]),
      _createVNode(_unref(TirPmInput), {
        isAutocomplete: "",
        label: "Повторите пароль",
        type: typeSecondPassword.value,
        modelValue: secondPassword.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((secondPassword).value = $event)),
        placeholder: "",
        isWithHint: showPlateWarning.value,
        "is-show-hint": showPlateWarning.value,
        onInput: onTypeOfInput,
        isWithSuccess: isSuccessEqualsPasword.value,
        isWithError: showPlateWarning.value
      }, {
        leftInputAddons: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_unref(KeyIcon))
          ])
        ]),
        hintMessage: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMessage.value), 1)
        ]),
        rightInputAddons: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["layout-login__input-addons layout-login__input-addons--action", {
              'layout-login__input-addons--show': secondPassword.value.length,
            }])
          }, [
            (!showSecondPassword.value)
              ? (_openBlock(), _createBlock(_unref(EyeIcon), {
                  key: 0,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (showSecondPassword.value = !showSecondPassword.value))
                }))
              : _createCommentVNode("", true),
            (showSecondPassword.value)
              ? (_openBlock(), _createBlock(_unref(EyeSlashIcon), {
                  key: 1,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (showSecondPassword.value = !showSecondPassword.value))
                }))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _: 1
      }, 8, ["type", "modelValue", "isWithHint", "is-show-hint", "isWithSuccess", "isWithError"])
    ])
  ], 512))
}
}

})